import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ABC_ICON } from "../../assets";
import { authService, userService } from "../../service";
import { loaderContext } from "../../context/context";
import { useModal } from "../../hooks";
import Modal from "../modals/Modal";

function SideNav() {
  return (
    <div className="side-nav">
      <div className="nav">
        <div className="nav-head">
          <div className="abc-icon">
            <img src={ABC_ICON} />
          </div>
        </div>
        <div className="nav-body pb-4">
          <div className="list list-wrapper">
            {Object.keys(sideNavdata).map((key) => (
              <>
                <div className="list-title">{key}</div>
                {sideNavdata[key].map((menu) => {
                  if (
                    userService.userData.isAdmin &&
                    menu?.for?.toUpperCase() === "ADMIN"
                  ) {
                    return <SideNavItem menu={menu} parentMenu={true} />;
                  } else if (menu.for === "*") {
                    return <SideNavItem menu={menu} parentMenu={true} />;
                  }
                })}
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideNav;

const SideNavItem = ({ menu, parentMenu }) => {

  const navigate = useNavigate();

  const [isExpand, setExpand] = useState(
    window.location.pathname.includes(menu.path) || false
  );

  const isActive = () => {
    const pathname = window.location.pathname.includes(menu.path);
    if (pathname) {
      return parentMenu || menu.children ? "parent-active" : "child-active";
    }

    return window.location.pathname === "/" && menu.default
      ? "parent-active"
      : "";
  };

  const redirect = () => {
    navigate(menu.path);
  };

  if (userService?.userData?.mercid==="MRC0002" && menu.id==="SINGLEINVOICE") {
    return
  } else{
    return (
      <>
        <div
          className={`list-item ${isActive(menu)}`}
          onClick={() => {
            setExpand(!isExpand);
            menu.path && !menu.children && redirect();
          }}
        >
          {menu.icon && <div className="list-icon">{menu.icon}</div>}
          <div className="list-details">{menu.title}</div>
          <div className="list-icon">
            {menu.children &&
              ((isExpand && (
                <span class="material-symbols-rounded">expand_more</span>
              )) || <span class="material-symbols-rounded">chevron_right</span>)}
          </div>
        </div>
        {menu?.children && isExpand && (
          <div className="list-sub-item expand">
            {menu.children.map((submenu) => (
              <SideNavItem menu={submenu} />
            ))}
          </div>
        )}
      </>
    );
  }

};

const sideNavdata = {
  mainmenu: [
    {
      id: "OVERVIEW",
      icon: <span class="material-symbols-rounded">dashboard</span>,
      title: "Overview",
      path: "/overview",
      for: "*",
      default: true,
      isEnabled: true,
    },
    {
      id: "CAMPAIGN",
      icon: <span class="material-symbols-rounded">campaign</span>,
      title: "Campaign",
      path: "/campaign",
      isEnabled: true,
      for: "*",
      children: [
        {
          id: "SINGLEINVOICE",
          title: "Invoice",
          path: "/campaign/invoice",
          isEnabled: false,
        },
        {
          id: "BULKCAMPAIGN",
          title: "Batch Upload",
          path: "/campaign/bulkupload",
          isEnabled: true,
        },
      ],
    },
  ],
  management: [
    {
      icon: <span class="material-symbols-rounded">table_chart</span>,
      title: "Templates",
      id: "TEMPLATES",
      path: "/templates",
      isEnabled: true,
      for: "*",
      children: [
        {
          id: "SMSTEMPLATES",
          title: "SMS",
          path: "templates/sms",
          isEnabled: true,
        },
        {
          id: "EMAILTEMPLATES",
          title: "Email",
          path: "templates/email",
          isEnabled: true,
        },
        {
          id: "WSTEMPLATES",
          title: "Whatsapp",
          path: "templates/whatsapp",
          isEnabled: true,
        },
      ],
    },
    {
      id: "USER",
      icon: <span class="material-symbols-rounded">person</span>,
      title: "User",
      path: "/user",
      for: "ADMIN",
      isEnabled: true,
      children: [
        {
          id: "LISTUSER",
          title: "List",
          path: "user/list",
          isEnabled: true,
        },
        // {
        //   id: "USERROLES",
        //   title: "Roles",
        //   path: "user/role",
        //   isEnabled: true,
        // },
      ],
    },
  ],
};
